import { render, staticRenderFns } from "./MenuRegister.vue?vue&type=template&id=6dc690ae&scoped=true"
import script from "./MenuRegister.vue?vue&type=script&lang=js"
export * from "./MenuRegister.vue?vue&type=script&lang=js"
import style0 from "./MenuRegister.vue?vue&type=style&index=0&id=6dc690ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc690ae",
  null
  
)

export default component.exports